// extracted by mini-css-extract-plugin
export default {"container":"Table_container__t+Lwe","table_head":"Table_table_head__DKl9D","header":"Table_header__5LdQZ","sortable":"Table_sortable__Xw-+g"};